export const FIRST_NAME_MAX_LENGTH = 35;
export const LAST_NAME_MAX_LENGTH = 60;

// CMS matches names literally after uppercasing, so only keep what can match a Medicare record.
// One Latin combining mark per letter, so a stack of marks or a mark from another script fails.
const LETTER = String.raw`\p{Script=Latin}[̀-ͯ]?`;
const NAME_PATTERN = new RegExp(String.raw`^(?:${LETTER})+(?:(?:[ '-]|\. ?)(?:${LETTER})+)*\.?$`, 'u');

// NFKC folds fullwidth and ligature forms to plain letters. iOS smart punctuation types a curly
// apostrophe, and Medicare records hold a straight one.
export const normalizeName = (name: string): string =>
  name.normalize('NFKC').replace(/[‘’]/g, "'").trim().replace(/\s+/g, ' ');

export const nameIsTooLong = (name: string, maxLength: number): boolean =>
  normalizeName(name).length > maxLength;

export const nameIsValid = (name: string, maxLength: number): boolean =>
  !nameIsTooLong(name, maxLength) && NAME_PATTERN.test(normalizeName(name));
